import { defineAgent } from '../agent-definition';
import { TITLE_SUPPORT_WORKSPACE_AGENT_TYPE } from '../agent-types';

export const TITLE_SUPPORT_WORKSPACE_AGENT = defineAgent({
  agentType: TITLE_SUPPORT_WORKSPACE_AGENT_TYPE,
  agentName: 'Insights Agent',
  prefixNameWithProduct: false,
  triggerLabel: 'Converse with the agent',
  triggerKind: 'tertiary',
  inputPlaceholder: 'Ask about this title support workspace…',
  starters: [
    {
      title: 'Summarize this workspace',
      prompt:
        'Summarize this workspace: its tracts, vesting documents, attached workbooks and both comparison summaries.',
    },
    {
      title: 'Which cited instruments does Insights not hold?',
      prompt:
        'From the runsheet comparison, list the report rows whose cited instrument Insights does not hold.',
    },
    {
      title: 'Where does ownership disagree?',
      prompt:
        'From the ownership comparison, list the rows where the report and the CRM tract bundle disagree, and flag any where the CRM disagrees with itself.',
    },
  ],
});
